import React, { useContext, useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import { useMutation } from "@apollo/client";

import { ipsPoints } from "./ipsPoints";
import Label from "../../reuseableComponents/label/Label";
import { ReactSelectAdapter } from "../../reuseableComponents/forms/ReactSelectAdapter";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import ButtonDelete from "../../reuseableComponents/buttons/ButtonDelete";
import ButtonProcessing from "../../reuseableComponents/buttons/ButtonProcessing";
import { UserContext } from "../../reuseableComponents/auth/UserContext";
import {
  ADD_NEW_VIOLATIONS,
  GET_ALL_IPS_VIOLATIONS,
  UPDATE_VIOLATION,
  DELETE_VIOLATION
} from "../../../queries/archiveQrys/secureQrys/ipsViolationQrys";
import Select from "react-select";

//TODO: verify options
let rtc = [
  { value: "X", label: "Enforcement Action SOX" },
  { value: "T", label: "Operational Year" }
];

const IpsViolationsForm = ({
  anlyts,
  grps,
  analytesList,
  violationsList,
  sectionsList,
  tableData,
  item,
  successMsg,
  errorMsg,
  setSubmitSuccess,
  setSubmitError,
  id,
  handleClose
}) => {
  //filter analytesList based on which violation is selected in an onChange function
  //find which item in the list should be eliminated based on the tableData

  //filter violationsList based on which analyte/aGroup is selected in an onChange function
  //find which item in the list should be eliminated based on the tableData

  const [formSubmitting, setFormSubmitting] = useState(false);

  const [aList, setAnalytesList] = useState(analytesList);
  const [vList, setViolationsList] = useState(violationsList);
  const [analyte, setAnalyte] = useState(null);
  const [violation, setViolation] = useState(null);

  useEffect(() => {
    if (item && id === "Edit" && analyte === null) {
      setAnalyte({ value: item.analyteValue, label: item.analyteLabel });
      setViolation({ value: item.violationId, label: item.violationName });
    }
  }, [setAnalyte, item, id, analyte]);

  const [addViolation] = useMutation(ADD_NEW_VIOLATIONS, {
    refetchQueries: [{ query: GET_ALL_IPS_VIOLATIONS }],
    awaitRefetchQueries: true
  });

  const [updateViolation] = useMutation(UPDATE_VIOLATION, {
    refetchQueries: [{ query: GET_ALL_IPS_VIOLATIONS }],
    awaitRefetchQueries: true
  });

  const [deleteViolation] = useMutation(DELETE_VIOLATION, {
    refetchQueries: [{ query: GET_ALL_IPS_VIOLATIONS }],
    awaitRefetchQueries: true
  });

  const { user } = useContext(UserContext);
  const username = user.firstName.charAt(0).toLowerCase() + user.lastName.toLowerCase();
  const today = new Date();

  const onSubmit = (data) => {
    setFormSubmitting(true);
    if (analyte) {
      data.analyte = { value: analyte.value, label: analyte.label };
    }
    if (violation) {
      data.violationName = { value: violation.value, label: violation.label };
    }
    if (id === "Delete") {
      deleteViolation({
        variables: {
          ipsPointId: data.ipsPointId
        },
        onCompleted: (data) => {
          setSubmitError(null);
          setFormSubmitting(false);
          setSubmitSuccess("Violation Deleted");
          setTimeout(() => {
            handleClose();
          }, 2000);
        },
        onError: (error) => {
          setFormSubmitting(false);
          setSubmitSuccess(null);
          setSubmitError("Error Deleting Violation");
        }
      });
    } else {
      if (data.analyte || data.analyte.value) {
        const isGrp = grps.some((grp) => grp.label === data.analyte.label);
        const isAnlyt = anlyts.some((anlyt) => anlyt.label === data.analyte.label);

        if (isGrp && isAnlyt) {
        } else if (isGrp) {
          data.anlytGrpId = data.analyte.value;
          data.isGrpAnalyte = true;
        } else {
          data.isGrpAnalyte = false;
        }
      }

      if (!data.violationName || !data.violationName.value) {
        setSubmitError("Please enter a value for violation type");
        setFormSubmitting(false);
        return;
      } else if (!data.analyte || !data.analyte.value) {
        if (!data.anlytGrpId) {
          setSubmitError("Please enter a value for analyte / analyte group");
          setFormSubmitting(false);
          return;
        }
      } else if (
        data.ipsPoints === undefined ||
        data.ipsPoints.value === undefined ||
        !ipsPoints.some((point) => point.value === data.ipsPoints.value)
      ) {
        setSubmitError("Please select a points value from the dropdown menu");
        setFormSubmitting(false);
        return;
      } else if (!data.returnToComplianceMethod || !data.returnToComplianceMethod.value) {
        setSubmitError("Please enter a value for return to compliance");
        setFormSubmitting(false);
        return;
      } else if (!data.section || !data.section.value) {
        setSubmitError("Please enter a value for violation section");
        setFormSubmitting(false);
        return;
      } else {
        setSubmitError(null);
      }

      if (id === "Edit") {
        const skipKeys = ["lastUpdateDate", "violationName", "lastUpdateUser", "analyte"];
        const isDataChanged = Object.keys(data).some((key) => {
          if (skipKeys.includes(key)) {
            return false;
          }
          if (key === "ipsPoints") {
            return data[key]?.value !== item[key];
          }
          if (key === "returnToComplianceMethod") {
            return data[key]?.value !== item[key];
          }
          if (key === "section") {
            return data[key]?.value !== item["reportId"];
          }
          return data[key] !== item[key];
        });

        if (!isDataChanged) {
          setFormSubmitting(false);
          setSubmitError("Please edit a value before submitting");
          return;
        }

        updateViolation({
          variables: {
            ...data,
            ipsPoints: data.ipsPoints.value,
            returnToComplianceMethod: data.returnToComplianceMethod.value,
            reportId: data.section ? data.section.value : null,
            ruleName: data.ruleName
          },
          onCompleted: (data) => {
            setFormSubmitting(false);
            setSubmitError(null);
            setSubmitSuccess("Update Successful");

            setTimeout(() => {
              handleClose();
            }, 2000);
          },
          onError: (error) => {
            setFormSubmitting(false);
            setSubmitSuccess(null);
            setSubmitError("Error Editing Violation");
          }
        });
      }
      if (id === "Add") {
        addViolation({
          variables: {
            ...data,
            ipsPoints: data.ipsPoints.value,
            returnToComplianceMethod: data.returnToComplianceMethod.value,
            anlytGrpId: data.anlytGrpId ? data.anlytGrpId : null,
            analyteId: data.anlytGrpId ? null : data.analyte.value,
            analyteLabel: analyte.label,
            analyteValue: analyte.value,
            violationId: parseInt(data.violationName.value.split(",")[0]),
            violationStCode: data.violationName.value.split(",")[1].trim(),
            reportId: data.section ? data.section.value : null,
            ruleName: data.ruleName
          },
          onCompleted: (data) => {
            setFormSubmitting(false);
            setSubmitError(null);
            setSubmitSuccess("Violation Created");
            setTimeout(() => {
              handleClose();
            }, 2000);
          },
          onError: (error) => {
            setFormSubmitting(false);
            setSubmitSuccess(null);
            setSubmitError("Error Creating Violation");
          }
        });
      }
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={
              item
                ? {
                    ...item,
                    returnToComplianceMethod: {
                      value: item.returnToComplianceMethod,
                      label: rtc.find((option) => option.value === item.returnToComplianceMethod)?.label || ""
                    },
                    ipsPoints: { label: item.ipsPoints, value: item.ipsPoints },
                    lastUpdateUser: username,
                    lastUpdateDate: today.toISOString(),
                    section: { label: item.reportName, value: item.reportId }
                  }
                : { lastUpdateUser: username, lastUpdateDate: today.toISOString() }
            }
            render={({ handleSubmit, form, submitting, values }) => (
              <form onSubmit={handleSubmit}>
                {id === "Delete" && (
                  <div>
                    {item && (
                      <p>Are you sure you want to delete violation {item.violationName + " " + item.analyteLabel}?</p>
                    )}
                    <Row>
                      <Col>
                        {formSubmitting ? (
                          <ButtonProcessing label='Deleting...' style={{ float: "right", color: "red" }} disabled />
                        ) : (
                          <ButtonDelete style={{ float: "right" }} onClick={() => onSubmit(item)} />
                        )}
                      </Col>
                      {errorMsg && !formSubmitting && <span className='error'>{errorMsg}</span>}
                      {successMsg && !formSubmitting && <span className='success'>{successMsg}</span>}
                    </Row>
                  </div>
                )}
                {id !== "Delete" && id && (
                  <>
                    <Row>
                      <Col>
                        <Label htmlFor='violation-type' label='Violation Type' required={id !== "Edit"} />
                        <Select
                          name='violationName'
                          options={vList}
                          className='mb-4'
                          isDisabled={id === "Edit" || formSubmitting}
                          required={id !== "Edit"}
                          defaultValue={
                            item
                              ? { label: item.violationName, value: item.violationId + ", " + item.violationStCode }
                              : { value: null, label: null }
                          }
                          onChange={(selectedViolation) => {
                            setViolation({ value: selectedViolation.value, label: selectedViolation.label });

                            // Filter violations based on existing violation-analyte pairs
                            const parts = selectedViolation.value.split(",");
                            const id = parseInt(parts[0].trim());
                            const code = parts[1].trim();
                            const selectedPairs = tableData.filter(
                              (pair) => pair.violationId === id && pair.violationStCode === code
                            );

                            const filteredAnalytes = analytesList.filter((analyte) => {
                              // Check if the analyte is already paired with the selected violation
                              return !selectedPairs.some((pair) => {
                                return pair.analyteLabel === analyte.label;
                              });
                            });
                            setAnalytesList(filteredAnalytes);
                          }}
                        />
                      </Col>
                      <Col>
                        <Label htmlFor='analyte' label='Analyte / Analyte Group' required={id !== "Edit"} />
                        <Select
                          name='analyte'
                          options={aList}
                          className='mb-4'
                          isDisabled={id === "Edit" || formSubmitting}
                          required={id !== "Edit"}
                          defaultValue={
                            item ? { label: item.analyteLabel, value: item.analyteValue } : { label: null, value: null }
                          }
                          onChange={(selectedAnalyte) => {
                            setAnalyte({ value: selectedAnalyte.value, label: selectedAnalyte.label });

                            // Filter violations based on existing violation-analyte pairs
                            const selectedPairs = tableData.filter(
                              (pair) => pair.analyteLabel === selectedAnalyte.label
                            );
                            const filteredViolations = violationsList.filter((violation) => {
                              // Check if the violation is already paired with the selected analyte
                              return !selectedPairs.some((pair) => {
                                const parts = violation.value.split(",");
                                const id = parseInt(parts[0].trim());
                                const code = parts[1].trim();
                                return pair.violationId === id && pair.violationStCode === code;
                              });
                            });
                            setViolationsList(filteredViolations);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Label htmlFor='rule-name' label='Rule Name' required />
                        <Field
                          name='ruleName'
                          component='input'
                          type='text'
                          className={formSubmitting ? "form-control-plaintext mb-4" : "form-control mb-4"}
                          disabled={formSubmitting}
                          required={true}
                        />
                      </Col>
                      <Col>
                        <Label htmlFor='ips points' label='IPS Points' required />
                        <Field
                          name='ipsPoints'
                          component={ReactSelectAdapter}
                          options={ipsPoints}
                          disabled={formSubmitting}
                          className={formSubmitting ? "form-control-plaintext" : "mb-4"}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Label htmlFor='returnToComplianceMethod' label='Return To Compliance' required />
                        <Field
                          name='returnToComplianceMethod'
                          options={rtc}
                          component={ReactSelectAdapter}
                          className='mb-4'
                          disabled={formSubmitting}
                        />
                      </Col>
                      <Col>
                        <Label htmlFor='section' label='IPS Violation Section' required />
                        <Field
                          name='section'
                          component={ReactSelectAdapter}
                          options={sectionsList}
                          className='mb-4'
                          disabled={formSubmitting}
                          required={id !== "Edit"}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {formSubmitting ? (
                          <ButtonProcessing id='ddw-primary' style={{ float: "right" }} disabled />
                        ) : (
                          <ButtonSubmit id='ddw-primary' style={{ float: "right" }} />
                        )}
                      </Col>
                      <span className='error'>{errorMsg}</span>
                      <span className='success'>{successMsg}</span>
                    </Row>
                  </>
                )}
              </form>
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default IpsViolationsForm;
